module.exports = __webpack_public_path__ + "img/carlo.2bc9ffb3.svg";